// extracted by mini-css-extract-plugin
export default {"contenedor-titulo-pagina-inicio":"InicioTitulo_contenedor-titulo-pagina-inicio__NtQbW","h1-titulo":"InicioTitulo_h1-titulo__8z-o-","h2-titulo":"InicioTitulo_h2-titulo__Cf5a2"};